<template>
  <div class="precaution">
    <legend class="m-0 text-left fs-24-bold mt-4 mb-2">
      撮影時の注意点
    </legend>
    <b-card class="px-lg-5 pb-lg-5">
      <div class="mt-lg-3">
        <h6 class="fs-18-bold">本人確認書類について</h6>
      </div>

      <div class="pl-3 mt-3 text-info fs-12-regular">
        <p class="mb-1">
          申込みにあたり、<span class="text-danger">代表者のお名前・生年月日</span>の確認が必要となります。<br>
          下記の本人確認書類のうち、<span class="text-danger">いずれか1点</span>をお選びいただき、ご送付ください。<br>
        </p>

        <ul class="mb-3">
          <li>運転免許証</li>
          <li>健康保険被保険者証</li>
          <li>法人の印鑑証明書</li>
        </ul>
      </div>

      <div>
        <h6 class="fs-16-bold">撮影する前に・・・</h6>
      </div>

      <div>
        <img
          src="../../assets/shoot_example.png"
          :width="computeImageWidth"
          height="auto"
        />
        <p class="pl-3 my-2 fs-12-regular text-info">室内の照明が反射する場合は、壁などに立てかけて撮影することで光の反射を防げます。</p>
      </div>

      <ul class="fs-12-regular text-info">
        <li>裏面に記載がある場合は、同様にご提出をお願いします。</li>
        <li>穴のあいた運転免許証は受付できません。</li>
      </ul>

      <div>
        <b-col class="col-md-6">
          <p class="text-danger fs-16-bold mb-2">以下、ご確認ください。</p>
            <ul class="fs-12-bold ml-0 pl-0 mb-2">
              <li>鮮明に写しての提出が必要な項目</li>
            </ul>

            <div class="ml-3 fs-12-bold mb-2">
              <span>&#9312;</span>有効期限<br>
              <span>&#9313;</span>公安委員会名称<br>
              <span>&#9314;</span>公安印<br>
              <span>&#9315;</span>代表者氏名<br>
              <span>&#9316;</span>代表者住所（手書きの場合原本に記入の上提出してください）<br>
              <span>&#9317;</span>代表者生年月日<br>
              <span>&#9318;</span>代表者性別<br>
              <span>&#9319;</span>有効期限<br>
              <span>&#9320;</span>交付日<br>
              <span>&#9321;</span>（ 被扶養者の場合）ご自身のお名前が記載されているページ。<br>
            </div>

            <ul class="fs-12-bold mt-3 ml-0 pl-0 mb-2">
              <li>必ず塗りつぶして提出していただく項目</li>
            </ul>
            <div class="ml-3 mb-3 fs-12-bold mb-2">
              <span>&#9312;</span>「本籍（住所欄が「同上」の場合は除く）」<br>
              <span>&#9313;</span>「免許の条件等」<br>
              <span>&#9314;</span>「臓器提供意思確認欄」<br>
              <span>&#9315;</span>（ある場合） 通院歴やご家族の情報の記載<br>
            </div>
            <p class="fs-12-regular text-info">※上記以外の項目は塗りつぶさずに提出してください。</p>
        </b-col>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'PrecautionsWhenShooting',
  computed: {
    isSpUserAgent () {
      return navigator.userAgent.match(/iPhone|Android.+Mobile/)
    },
    computeImageWidth () {
      return this.isSpUserAgent ? '100%' : '50%'
    }
  }
}
</script>

<style scoped>
.precaution {
  padding: .5rem  1.25rem;
}

.head {
  padding: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.copyright {
  margin: 2rem 0 0;
  padding: 1rem 1rem 0;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
